export default {
  setEngagementSpellCheckDictionaries(state, payload) {
    state.engagementSpellCheckDictionaries = payload;
  },
};
